import { Injectable } from '@angular/core';
import { Actions as EffectActions, createEffect, ofType } from '@ngrx/effects';
import { ActionType } from './store/actions/sites.actions';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as Actions from './store/actions/sites.actions';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Site } from './sites.model';
import { SitesService } from './sites.service';


@Injectable({
  providedIn: 'root'
})
export class SitesEffects {

  url = 'https://localhost:44358';

  constructor(
    private actions$: EffectActions,
    private http: HttpClient,
    private sitesService: SitesService
  ) { }

  
  fetchSitesRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_SITES),
      mergeMap((action: Actions.FetchSites) => {

        return this.sitesService.getSites$()
          .pipe(
            mergeMap((response: any) => {
              response.forEach((site: any) => {
                site.startDate = site.startDate.toDate();
              });
              console.log('fetchSitesRequest...', response);
              return ([
                new Actions.FetchSitesSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchSitesFailed(err));
            })

          );
      })
    ));

  
  fetchSitesByCompanyIdRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_SITES_BY_COMPANYID),
      mergeMap((action: Actions.FetchSitesByCompanyId) => {

        return this.sitesService.getSitesByCompanyId$(action.companyId)
          .pipe(
            mergeMap((response: any) => {
              response.forEach((site: any) => {
                site.startDate = site.startDate.toDate();
              });
              // console.log('fetchSitesRequestByCompanyId...', response);
              return ([
                new Actions.FetchSitesByCompanyIdSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchSitesByCompanyIdFailed(err));
            })

          );
      })
    ));

    
    fetchSitesByCompanyIdSiteIdRequestFirebase = createEffect(() => this.actions$
      .pipe(
        ofType(ActionType.FETCH_SITES_BY_COMPANYIDSITEID),
        mergeMap((action: Actions.FetchSitesByCompanyIdSiteId) => {

          return this.sitesService.getSitesByCompanyIdSiteId$(action.companyId, action.siteId)
            .pipe(
              mergeMap((response: any) => {
                response.forEach((site: any) => {
                  site.startDate = site.startDate.toDate();
                });

                // map((productGroups: Site[]) => productGroups.filter((productGroup: Site) => (productGroup.id = action.companyId))),

                return ([
                  new Actions.FetchSitesByCompanyIdSiteIdSuccess(response)
                ]);
              }
              ),
              catchError(err => {
                console.log('Handling error locally and rethrowing it...', err);
                return of(new Actions.FetchSitesByCompanyIdSiteIdFailed(err));
              })

            );
        })
      ));


  // @Effect()
  // fetchSitesByCompanyIdRequest = this.actions$
  //   .pipe(
  //     ofType(ActionType.FETCH_SITES_BY_COMPANYID),
  //     mergeMap((action: Actions.FetchSitesByCompanyId) => {

  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.get<Site[]>(this.url + '/api/Sites/GetSitesByCompanyId/' + action.companyId, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('action.companyId...', action.companyId);
  //             console.log('fetchSitesByCompanyIdRequest...', response);
  //             return ([
  //               new Actions.FetchSitesByCompanyIdSuccess(response)
  //             ])
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.FetchSitesByCompanyIdFailed(err));
  //           })

  //         )
  //     })
  //   )

  
  fetchSitesRequest = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_SITES),
      mergeMap((action: Actions.FetchSites) => {

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.get<Site[]>(this.url + '/api/Sites', httpOptions)
          .pipe(
            mergeMap((response: any) => {
              console.log('fetchSitesRequest...', response);
              return ([
                new Actions.FetchSitesSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchSitesFailed(err));
            })

          );
      })
    ));

  // @Effect()
  // addBug = this.actions$
  //   .pipe(
  //     ofType(ActionType.ADD_SITE),
  //     mergeMap((action: Actions.AddSite) => {

  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       let sites = action.site;
  //       sites = { ...sites };

  //       return this.http.post<Site>(this.url + '/api/Sites/', sites, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.AddSiteSuccess(response)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.AddSiteFailed());
  //           })

  //         );
  //     })
  //   );

  
  addSiteFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.ADD_SITE),
      mergeMap(async (action: Actions.AddSite) => {

        const site = action.site;

        await this.sitesService.addSiteFirebase$(site)
          .then((response: any) => {
            site.id = response.id;
            console.log('site...', site);
          }).catch((err: any) => {
            // site.id = null;
            console.log('err in catch...', err);
          });

        if (site.id !== null) {
          return new Actions.AddSiteSuccess(site);
        } else {
          return new Actions.AddSiteFailed();
        }
      })
    ));

  // @Effect()
  // deleteBug = this.actions$
  //   .pipe(
  //     ofType(ActionType.DELETE_SITE),
  //     mergeMap((action: Actions.DeleteSite) => {
  //       const id = action.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.delete<number>(this.url + '/api/Sites/' + id, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.DeleteSiteSuccess(response.id)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.DeleteSiteFailed());
  //           })

  //         );
  //     })
  //   );


  
  destroyChannelFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.DESTROY_SITE),
      mergeMap(async (action: Actions.DestroySite) => {

        const id = action.id;

        await this.sitesService.destroySiteFirebase$(id)
          .then((response: any) => {
            console.log('response...', response);
          }).catch((err: any) => {
            console.log('err in catch...', err);
          });

        if (id !== null) {
          return new Actions.DestroySiteSuccess(id);
        } else {
          return new Actions.DestroySiteFailed();
        }
      })
    ));

  // @Effect()
  // destroySite = this.actions$
  //   .pipe(
  //     ofType(ActionType.DESTROY_SITE),
  //     mergeMap((action: Actions.DestroySite) => {
  //       const id = action.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.delete<number>(this.url + '/api/Sites/' + id, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.DestroySiteSuccess(response.id)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.DestroySiteFailed());
  //           })

  //         );
  //     })
  //   );

  // @Effect()
  // updateBug = this.actions$
  //   .pipe(
  //     ofType(ActionType.UPDATE_SITE),
  //     mergeMap((action: Actions.UpdateSite) => {

  //       const message = action.site;
  //       const id = action.site.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       const site = action.site;

  //       return this.http.put<Site>(this.url + '/api/Sites/' + id, site, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {

  //             console.log('response updateBug...', site);
  //             return ([
  //               new Actions.UpdateSiteSuccess(site.id, site)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.UpdateSiteFailed());
  //           })

  //         );
  //     })
  //   );

  
  // updateSiteFirebase = createEffect(() => this.actions$
  //   .pipe(
  //     ofType(ActionType.UPDATE_SITE),
  //     mergeMap((action: Actions.UpdateSite) => {

  //       const site = action.site;

  //       return this.sitesService.updateSiteFirebase$(site)
  //         .pipe(
  //           mergeMap((response: any) => {

  //             console.log('response updateSiteFirebase...', site);
  //             site.id = '';
  //             return ([
  //               new Actions.UpdateSiteSuccess(site.id, site)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.UpdateSiteFailed());
  //           })

  //         );
  //     })
  //   ));
}
